<template>
  <router-link v-slot="{ isActive, href, navigate }" :to="link.route ?? ''" custom>
    <a
      v-bind="$attrs"
      :href="href"
      :class="[
        isActive
          ? 'text-[--header-bottom-link-active-color]'
          : 'text-[--header-bottom-link-color] hover:text-[--header-bottom-link-hover-color]',
      ]"
      class="md:px-2 lg:px-3 font-semibold text-[color:var(--color-header-bottom-link)] hover:text-[color:var(--color-header-bottom-link-hover)]"
      @click="navigate"
    >
      <span class="relative">
        <slot name="icon">
          <VcIcon v-if="link.icon" :name="link.icon" :size="30" class="mb-0.5 fill-primary" />
        </slot>

        <transition mode="out-in" name="scale">
          <VcBadge v-if="count" class="absolute -right-3 -top-2 transition-transform p-0.5" variant="outline" rounded>
            {{ $n(count, { style: "decimal", notation: "compact" }) }}
          </VcBadge>
        </transition>
      </span>

      <span>
        <slot />
      </span>
    </a>
  </router-link>
</template>

<script setup lang="ts">
import type { ExtendedMenuLinkType } from "@/core/types";

interface IProps {
  link: ExtendedMenuLinkType;
  count?: number;
}

defineOptions({
  inheritAttrs: false,
});

withDefaults(defineProps<IProps>(), {
  count: 0,
});
</script>
